import { useCart } from '@corratech/pylot-cart-manager'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { Cart } from '@pylot-data/pylotschema'
import { useTrackCheckoutStep } from '../hooks'
import { CheckoutStepNameEnum } from '@config/seo/checkoutSteps'
import { CHECKOUT_PAGE_ROUTE } from './useTrackCheckoutPageStep'
import { parseUrlPathName } from '../utils/parseUrlPathName'

const getShippingMethodTitle = ({
    shipping_addresses
}: Cart): string | undefined => {
    if (!Array.isArray(shipping_addresses) || shipping_addresses.length === 0) {
        return
    }
    for (const address of shipping_addresses) {
        if (address?.selected_shipping_method?.carrier_title) {
            return address.selected_shipping_method.carrier_title
        }
    }
}

export const useTrackShippingMethod = (): void => {
    const { isFallback, asPath } = useRouter()
    const trackCheckoutStep = useTrackCheckoutStep()
    const { data, isValidating } = useCart({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const cart = data?.data?.cart
    const isOptimistic = data?.data?.isOptimistic
    useEffect(() => {
        const methodTitle = cart && getShippingMethodTitle(cart)
        if (
            methodTitle &&
            !isFallback &&
            !isOptimistic &&
            !isValidating &&
            parseUrlPathName(asPath) === CHECKOUT_PAGE_ROUTE
        ) {
            trackCheckoutStep({
                step: CheckoutStepNameEnum.SHIPPING,
                option: methodTitle
            })
        }
    }, [cart, isFallback, isValidating, isOptimistic])
}
